import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g transform="translate(2)">
      <rect width="16" height="2" x="6" y="18" className="euiIcon__fillSecondary"/>
      <rect width="9" height="2" x="6" y="13" className="euiIcon__fillSecondary"/>
      <rect width="16" height="2" x="6" y="23" className="euiIcon__fillSecondary"/>
      <path
        d="M19.41,0 L3,0 C1.34314575,-1.01453063e-16 4.4408921e-16,1.34314575 0,3 L0,29 C4.4408921e-16,30.6568542 1.34314575,32 3,32 L25,32 C26.6568542,32 28,30.6568542 28,29 L28,8.59 L19.41,0 Z M20,3.41 L24.59,8 L20,8 L20,3.41 Z M25,30 L3,30 C2.44771525,30 2,29.5522847 2,29 L2,3 C2,2.44771525 2.44771525,2 3,2 L18,2 L18,10 L26,10 L26,29 C26,29.5522847 25.5522847,30 25,30 Z"/>
    </g>
  </svg>
)
